import React from 'react';
import './main.scss';
import CommonLayout from '../../components/Common/Layout/layout';
import Blocks from '../../components/Common/Blocks/blocks';
import IconButton from '../../components/Common/IconButton/button';

const ContactsPage = () => {
    return (
        <>
            <CommonLayout backgroundColor={'white'}>
                <div className="contacts-container">
                    <h2>КОНТАКТИ</h2>
                    <p>ІНТЕРНЕТ-МАГАЗИН</p>
                    <div className="info-wrapper">
                        <div className="info-item">
                            <div className="info-item-icon">
                                <IconButton iconUrl={'icons/phone-black.svg'} width={25} height={25} />
                            </div>
                            <div className="info-item-col">
                                <div className="info-item-col-title">
                                    Телефон:
                                </div>
                                <div className="info-item-col-value">
                                    +38 (097) 023 0023
                                </div>
                            </div>
                        </div>
                        <div className="info-item">
                            <div className="info-item-icon">
                                <IconButton iconUrl={'icons/email-black.svg'} width={25} height={25} />
                            </div>
                            <div className="info-item-col">
                                <div className="info-item-col-title">
                                    Почта:
                                </div>
                                <div className="info-item-col-value">
                                    socks.23.site@gmail.com
                                </div>
                            </div>
                        </div>
                        <div className="info-item">
                            <div className="info-item-icon">
                                <IconButton iconUrl={'icons/time-black.svg'} width={25} height={25} />
                            </div>
                            <div className="info-item-col">
                                <div className="info-item-col-title">
                                    Робочі години:
                                </div>
                                <div className="info-item-col-value">
                                    Пн - Нд: 9:00 - 20:00<br />
                                </div>
                            </div>
                        </div>
                    </div>
                    <iframe class="grid-map__frame" data-qa="grid-map-iframe" width="100%" height="500px" src="https://maps.google.com/maps?q=%D0%B2%D1%83%D0%BB%D0%B8%D1%86%D1%8F%20%D0%9A%D0%B8%D1%97%D0%B2%D1%81%D1%8C%D0%BA%D0%B0%2C%2077%2C%20%D0%96%D0%B8%D1%82%D0%BE%D0%BC%D0%B8%D1%80%2C%20%D0%96%D0%B8%D1%82%D0%BE%D0%BC%D0%B8%D1%80%D1%81%D1%8C%D0%BA%D0%B0%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C%2C%2010002&amp;t=m&amp;z=13&amp;ie=UTF8&amp;output=embed" data-v-d752c768=""></iframe>

                </div>
            </CommonLayout>
        </>
    )
}

export default ContactsPage;